import React, { useState } from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import SetupScreen from './components/SetupScreen';
import InterviewScreen from './components/InterviewScreen';
import FeedbackScreen from './components/FeedbackScreen';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#6366f1' },
    secondary: { main: '#10b981' },
    background: { default: '#0f172a', paper: '#1e293b' },
    text: { primary: '#f1f5f9', secondary: '#94a3b8' },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
  },
});

export default function App() {
  const [screen, setScreen] = useState('setup'); // 'setup' | 'interview' | 'feedback'
  const [profile, setProfile] = useState(null);
  const [transcript, setTranscript] = useState([]);
  const [feedback, setFeedback] = useState(null);

  function handleSetupComplete(profileData) {
    setProfile(profileData);
    setScreen('interview');
  }

  function handleInterviewEnd(transcriptData) {
    setTranscript(transcriptData);
    setScreen('feedback');
  }

  function handleFeedbackReceived(feedbackData) {
    setFeedback(feedbackData);
  }

  function handleRestart() {
    setProfile(null);
    setTranscript([]);
    setFeedback(null);
    setScreen('setup');
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {screen === 'setup' && (
        <SetupScreen onComplete={handleSetupComplete} />
      )}
      {screen === 'interview' && profile && (
        <InterviewScreen
          profile={profile}
          onEnd={handleInterviewEnd}
        />
      )}
      {screen === 'feedback' && (
        <FeedbackScreen
          profile={profile}
          transcript={transcript}
          feedback={feedback}
          onFeedbackReceived={handleFeedbackReceived}
          onRestart={handleRestart}
        />
      )}
    </ThemeProvider>
  );
}
